// Offer catalog for the funnel. FE (Creator) is the main product sold on the
// landing; OTO1-OTO4 are upsells shown on their own sub-landing pages.
// Admins can override price / cadence / tagline / benefits per tier from Admin →
// License; those overrides live in app_config.tier_offers and merge over these.

// What each tier actually delivers. Video came out of every one of them when it
// was switched off: promising a talking-head clip on a sales page and hiding the
// button in the product is how a sixty-day guarantee turns into a refund rate.
export const DEFAULT_OFFERS = [
  {
    key: 'fe', name: 'Studio', price: '$37', cadence: 'one-time', highlight: true,
    tagline: 'Studio photography for what you sell, and for your own face.',
    features: [
      '100+ ready-made photo sessions',
      'Product shots, on-model and headshots',
      'A model who looks the same in every frame',
      'Node Studio + Guided Create',
      'Bring your own API key — photos cost you cents',
    ],
  },
  {
    key: 'oto1', name: 'Pro', price: '$67', cadence: 'one-time', highlight: false,
    tagline: 'Shoot without limits, and in batches.',
    features: [
      'Everything in Studio',
      'Unlimited sessions (your keys)',
      'All 16 looks',
      'Batch shoots and variations',
      'Upscale to print and listing sizes',
    ],
  },
  {
    key: 'oto2', name: 'Campaign', price: '$97', cadence: 'one-time', highlight: false,
    tagline: 'Turn one product into a full catalogue.',
    features: [
      'Everything in Pro',
      'Multi-angle catalogue generation',
      'Brand kits',
      'Every aspect ratio at once',
    ],
  },
  {
    key: 'oto3', name: 'Agency', price: '$197', cadence: 'one-time', highlight: false,
    tagline: 'Shoot for your clients.',
    features: [
      'Everything in Campaign',
      'Client workspaces',
      'Unlimited clients',
      'Bulk generation',
      'Commercial licence',
    ],
  },
  {
    key: 'oto4', name: 'Whitelabel', price: '$297', cadence: 'one-time', highlight: false,
    tagline: 'Your own photo studio platform.',
    features: [
      'Everything in earlier tiers',
      'Rebrand name, logo & colours',
      'Client workspaces & portal',
      'Resell as your own SaaS',
    ],
  },
];

export const OFFER_ORDER = ['fe', 'oto1', 'oto2', 'oto3', 'oto4'];
export const UPSELL_TIERS = ['oto1', 'oto2', 'oto3', 'oto4'];

function overlay(def, o) {
  o = o || {};
  return {
    ...def,
    price: o.price || def.price,
    cadence: o.cadence || def.cadence,
    tagline: o.tagline || def.tagline,
    features: o.features && o.features.length ? o.features : def.features,
  };
}

// Merge admin overrides (config.tier_offers) over the defaults -> full array.
export function mergeOffers(config) {
  const overrides = (config && config.tier_offers) || {};
  return DEFAULT_OFFERS.map((d) => overlay(d, overrides[d.key]));
}

export function getOffer(key, config) {
  const def = DEFAULT_OFFERS.find((d) => d.key === key);
  if (!def) return null;
  const overrides = (config && config.tier_offers) || {};
  return overlay(def, overrides[key]);
}

// Editable map keyed by tier for the Admin form (defaults filled in).
export function toEditableOffers(tierOffers) {
  const overrides = tierOffers || {};
  const out = {};
  DEFAULT_OFFERS.forEach((d) => {
    const o = overlay(d, overrides[d.key]);
    out[d.key] = { price: o.price, cadence: o.cadence, tagline: o.tagline, features: o.features };
  });
  return out;
}
